'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {
    var _StyleSheet$create, _ref;

    var theme = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var palette = theme.palette,
        rightTop = _variables.X_POSITION_RIGHT + '-' + _variables.Y_POSITION_TOP,
        rightBottom = _variables.X_POSITION_RIGHT + '-' + _variables.Y_POSITION_BOTTOM,
        leftBottom = _variables.X_POSITION_LEFT + '-' + _variables.Y_POSITION_BOTTOM,
        leftTop = _variables.X_POSITION_LEFT + '-' + _variables.Y_POSITION_TOP;


    var styleList = _aphroditeJss.StyleSheet.create((_StyleSheet$create = {
        root: {
            background: theme.background,
            boxShadow: theme.boxShadow,
            borderRadius: theme.borderRadius,
            zIndex: theme.zIndex
        },
        item: {
            background: palette.itemBackground,
            fontSize: theme.itemFontSize,
            lineHeight: theme.itemLineHeight,
            fontWeight: theme.itemFontWeight,
            color: theme.itemColor,
            transitionProperty: 'background',
            transitionDuration: palette.transitionDuration,
            transitionTimingFunction: palette.transitionFunction,
            paddingTop: theme.itemPaddingTop,
            paddingRight: theme.itemPaddingRight,
            paddingBottom: theme.itemPaddingBottom,
            paddingLeft: theme.itemPaddingLeft,

            '&:hover': {
                background: theme.hoverItemBackground,
                cursor: theme.hoverItemCursor,
                color: theme.hoverItemColor
            }
        },
        itemWrapper: {
            position: 'relative'
        }
    }, _defineProperty(_StyleSheet$create, rightTop, {
        position: 'absolute',
        top: 0,
        left: '100%'
    }), _defineProperty(_StyleSheet$create, rightBottom, {
        position: 'absolute',
        bottom: 0,
        left: '100%'
    }), _defineProperty(_StyleSheet$create, leftBottom, {
        position: 'absolute',
        right: '100%',
        bottom: 0
    }), _defineProperty(_StyleSheet$create, leftTop, {
        position: 'absolute',
        right: '100%',
        top: 0
    }), _StyleSheet$create));

    return _ref = {
        root: (0, _aphroditeJss.css)(styleList.root),
        item: (0, _aphroditeJss.css)(styleList.item)
    }, _defineProperty(_ref, rightTop, (0, _aphroditeJss.css)(styleList[rightTop])), _defineProperty(_ref, rightBottom, (0, _aphroditeJss.css)(styleList[rightBottom])), _defineProperty(_ref, leftBottom, (0, _aphroditeJss.css)(styleList[leftBottom])), _defineProperty(_ref, leftTop, (0, _aphroditeJss.css)(styleList[leftTop])), _defineProperty(_ref, 'itemWrapper', (0, _aphroditeJss.css)(styleList.itemWrapper)), _ref;
};

var _aphroditeJss = require('aphrodite-jss');

var _variables = require('../variables');

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }